import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

import { SingleFormResponse } from 'types/Forms';

const getFormByID = (formID: string | undefined | null) => {
  const url = generateURL(SPARK_RESOURCE_TYPES.FORMS, [], formID);

  return fetchWrapper<SingleFormResponse>({
    url: url,
    method: 'GET',
  });
};

export function useFormByID(formID: string | undefined | null) {
  const response = useQuery(
    [SPARK_RESOURCE_TYPES.FORMS, formID],
    () => getFormByID(formID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch Form: ${error.message}`);
        }
      },
      enabled: Boolean(formID),
      ...CACHE_AND_STALE_TIME,
    }
  );

  const form = response.data?.data;

  const isLoading = response.isLoading;
  const isFetch = response.isFetching;

  return {
    ...response,
    form,
    isLoading,
    isFetch,
  };
}
